import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { createEmbeddingContext, EmbeddingContext } from 'amazon-quicksight-embedding-sdk';
import { take } from 'rxjs';

import { AuxQuickSightDashboardType, GqlService } from '@shared/services/gql.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'aux-investigator-reconciliation-dashboard',
  templateUrl: './investigator-reconciliation-dashboard.component.html',
})
export class InvestigatorReconciliationDashboardComponent implements OnInit {
  private gqlService = inject(GqlService);

  ngOnInit() {
    this.getDashboardURL();
  }

  async getDashboard(embeddedURL: string) {
    const containerDiv =
      document.getElementById('investigatorReconciliationDashboardContainer') || '';
    const frameOptions = {
      container: containerDiv,
      height: '850px',
      resizeHeightOnSizeChangedEvent: true,
      url: embeddedURL,
      width: '100%',
    };
    const embeddingContext: EmbeddingContext = await createEmbeddingContext();

    void embeddingContext.embedDashboard(frameOptions);
  }

  getDashboardURL() {
    this.gqlService
      .generateEmbeddedQuickSightURL$(AuxQuickSightDashboardType.INVESTIGATOR_RECONCILIATION)
      .pipe(take(1))
      .subscribe(({ data }) => void this.getDashboard(data?.url || ''));
  }
}
